import styled from "styled-components";
import {
    CharcoalBlack,
    DarkSlate,
    ErrorRed,
    LightSlate,
    Silver,
    Smoke,
    Teal,
    White,
    GreyContent,
} from "../../../../theme/variable";
import registration_sprite from "../../../../images/registration_sprite.svg";
import zeroEmoji from "../../../../images/zeroEmoji.png";
import {media} from "../../../../theme/responsive";
import {CommonFieldStyled, CommonFieldLabel} from "../../CommonFieldStyled";
import {MULTI_SELECT} from "../utils";

export const SelectfieldDiv = styled(CommonFieldStyled)`
    top: -2px;
    margin-top: 16px;
`;

export const SelectfieldLabel = styled(CommonFieldLabel)`
    transform: ${(props) => {
        if (props.isFilled || props.isFocused || props.isError || props.disabled) {
            return `scale(0.8) translate3d(-24px,-14px,0);`;
        }

        return "";
    }};
    height: ${(props) => {
        if (props.isFilled || props.isError || props.isFocused || props.disabled) return `21px`;

        return "48px";
    }};
    line-height: ${(props) => {
        if (props.isFilled || props.isFocused || props.isError || props.disabled) return `21px`;

        return "48px";
    }};
    background: ${(props) => {
        if (props.isError || props.isFocused || props.isFilled) return `${White}`;
        return ``;
    }};
    padding: ${(props) => {
        if (props.isError || props.isFocused || props.isFilled) return "0 8px";
        return "";
    }};
    color: ${(props) => {
        if (props.disabled) {
            return `${LightSlate}`;
        } else {
            if (props.isFocused) return `${Teal}`;
            if (props.isError) return `${ErrorRed}`;
            if (props.isFilled) return `${CharcoalBlack}`;
        }
        return `${CharcoalBlack};`;
    }};
    position: absolute;
    -webkit-font-smoothing: antialiased;
    backface-visibility: hidden;
    transform-origin: unset;
    z-index: 0;
`;
export const SelectFilledLabel = styled.span`
    && {
        font-size: 0.9375rem;
        line-height: 47px;
        width: 90%;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        color: ${(props) => (props.disabled ? `${LightSlate}` : `${CharcoalBlack}`)};
        z-index: 1;
    }
`;
export const SelectBox = styled.div`
    display: flex;
    font-size: 0.9375rem;
    text-shadow: none;
    flex: 1 1 auto;
    order: 2;
    height: 48px;
    line-height: 48px;
    border-radius: 4px;
    padding: 0 15px;
    width: 100%;
    background: ${White};
    box-sizing: border-box;
    margin-bottom: 8px;
    border: ${(props) => {
        if (props.disabled) {
            return `1px solid ${Silver}`;
        } else {
            if (props.isError) return `2px solid ${ErrorRed}`;
            if (props.isFilled) return `1px solid ${DarkSlate}`;
            if (props.isFocused) return `2px solid ${Teal}`;
        }
        return `1px solid ${DarkSlate}`;
    }};
    color: ${(props) => {
        if (props.disabled) {
            return `${LightSlate}`;
        } else {
            if (props.isFilled || props.isFocused) return `${CharcoalBlack}`;
        }
        return `${CharcoalBlack}`;
    }};
    &:focus {
        outline: 0;
        border: ${(props) => (!props.disabled ? `2px solid ${Teal}` : ``)};
    }
    &:focus + ${SelectfieldLabel} {
        color: ${Teal};
        background: ${White};
        text-align: center;
        align-items: center;
    }
    &:after {
        content: "";
        background: url(${registration_sprite}) no-repeat;
        width: 14px;
        height: 12px;
        background-position: ${(props) => {
            if (props.disabled) {
                return `-44px -38px`;
            } else {
                if (props.isFocused) return `-24px -38px`;
            }
            return `-24px -38px`;
        }};
        transform: ${(props) => (props.isFocused ? "rotate(180deg)" : "")};
        transition: all 0.5s ease;
        position: absolute;
        top: 18px;
        right: 15px;
    }
    // > div {
    //     top: 56px;
    // }
`;
export const SelectTitle = styled.div`
    font-size: 0.75rem;
    line-height: 1.5;
    color: ${DarkSlate};
    width: 100%;
    background:${(props) => (props.withSearch === false ? "none" : `${GreyContent}`)};
    // background:${GreyContent};
    padding:${(props) => (props.withSearch === false ? "5px 0 3px" : `5px 15px`)};
    text-transform:capitalize;
`;
export const SelectListBox = styled.div`
    height: 100%;
    width: 100%;
    margin: 0;
    border-top: 0;
    border-radius: 0px;
    display: ${(props) => {
        return props.isOpen ? "block" : "none";
    }};
    overflow: auto;
    box-shadow: ${(props) => (props.isOpen ? `2px 2px 8px 0 rgba(0, 0, 0, 0.16)` : "")};

    text-align: left;
    background: ${(props) => (props.isOpen ? `${White}` : "")};
    position: ${(props) => (props.isOpen ? "fixed" : "absolute")};
    top: ${(props) => (props.isOpen ? "0px" : "")};
    right: 0px;
    bottom: 0px;
    left: 0px;
    z-index: ${(props) => (props.isOpen ? "9" : "")};
    &:focus {
        outline: none;
    }
    ${media.laptop`
        position:absolute;
        top: 48px;
        overflow:hidden;
        min-height:${(props) => {
            if (props.withSearch && props.type === MULTI_SELECT) {
                return "364px";
            } else {
                if (props.withSearch) return "335px";
            }
            return "260px";
        }};
               
        z-index: ${(props) => (props.isOpen ? "9" : "")};
        // width: 337px;
        width:100%;
        border-radius:4px;
        border: ${(props) => (props.isOpen ? `solid 1px ${Smoke}` : "")};
        @-moz-document url-prefix() {
            min-height:${(props) => {
                if (props.withSearch && props.type === MULTI_SELECT) {
                    return "390px";
                } else {
                    if (props.withSearch) return "350px";
                }
                return "260px";
            }};
        }
     `}
`;
export const SelectList = styled.ul`
    && {
        padding: ${(props) => (props.type === MULTI_SELECT ? "0px 16px 45px" : "0px 16px 20px")};
        margin: 0;
        -webkit-tap-highlight-color: transparent;
    }
    ${media.laptop`
        overflow-y: auto;
        height: 250px;
        background: ${White};
        padding: 11px 16px;
     `}
`;
export const SelectListItem = styled.li`
    && {
        width: ${(props) => {
            if (props.isHighligted && props.withOptGroup) {
                return ``;
            } else if (props.isHighligted) {
                return `100%`;
            } else {
                return `100%`;
            }
        }};
        list-style: none;
        box-sizing: ${(props) => {
            return props.withOptGroup ? "" : "content-box";
        }};
        padding: ${(props) => {
            if (props.isHighligted && props.withOptGroup) {
                return `12px 16px 12px 36px`;
            } else if (props.withOptGroup) {
                return `12px 0px 12px 0px`;
            } else if (props.isHighligted) {
                return `12px 12px`;
            } else {
                return `12px 0`;
            }
        }};
        font-size: 0.9375rem;
        line-height: 22px;
        color: ${(props) => {
            if (props.disabled) {
                return `${LightSlate}`;
            }
            return `${CharcoalBlack}`;
        }};
        cursor: pointer;
        background: ${(props) => (props.isHighligted ? "#f0f6ff" : `${White}`)};
        margin: ${(props) => {
            if (props.isHighligted && props.withOptGroup) {
                return "0px -16px -2px -36px";
            } else if (props.isHighligted) {
                return "0px -12px -2px -12px";
            } else {
                return "0px 0 -2px 0";
            }
        }}
`;
export const SelectSubTitle = styled.div`
    font-size: 0.9375rem;
    line-height: 1.6;
    font-weight: 600;
`;
export const SelectSubList = styled.ul`
    padding: 0px 0 0px 15px;
`;

export const SelectSeperator = styled.li`
    && {
        border-bottom: 1px solid #ccc;
        list-style: none;
        padding: 0;
        margin: 0;
        width: 100%;
        &:last-child {
            border-bottom: none;
        }
    }
`;
export const SelectSearchWrapper = styled.div`
    width: 100%;
    border: 1px solid ${DarkSlate};
    border-radius: 4px;
`;
export const SelectSearch = styled.div`
    padding: 12px;
    display: ${(props) => (props.isOpen ? "block" : "none")};
    position: relative;
    background: ${White};
    input[type="text"] {
        outline: none;
        width: 90%;
        font-size: 0.9375rem;
        line-height: 1.47;
        box-sizing: border-box;
        position: relative;
        padding: 13px 15px;
        border: none;
        border-radius: 4px 0 0 4px;
        &::placeholder {
            color: ${DarkSlate};
        }
    }
`;

export const SearchIcon = styled.div`
    content: "";
    background: url(${registration_sprite}) no-repeat;
    display: inline-block;
    width: 20px;
    height: 20px;
    background-position: ${(props) => (props.isSearchInputValue ? "-102px -61px" : "-72px -61px")};
    position: absolute;
    top: 27px;
    right: 26px;
    cursor: pointer;
`;
export const LayerSticky = styled.div`
    background: ${White};
    padding: 8px 0;
    position: fixed;
    bottom: 0;
    width: 100%;
    text-align: center;
    left: 0;
    right: 0;
    box-shadow: 0 -1px 2px 0 rgba(0, 0, 0, 0.18);
    button {
        padding: 0 50.5px;
    }
    span {
        color: ${DarkSlate};
        font-size: 0.75rem;
        position: absolute;
        left: 10px;
        bottom: 6px;
    }
    ${media.laptop`position: sticky;`}
`;
export const SelectZeroResults = styled.div`
    width: 100%;
    text-align: center;
    margin: 10px 0;
    p {
        font-size: 0.9375rem;
        line-height: 20px;
        margin-top: 0px;
    }
`;
export const SelectZeroResultIcon = styled.div`
    font-size: 1.2rem;
    background: url(${zeroEmoji}) no-repeat;
    width: 48px;
    height: 48px;
    margin: 0 auto;
    transform: scale(0.7);
`;
export const SelectSticky = styled.div`
    position: sticky;
    top: 0;
    background: ${White};
    z-index: 1;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.18);
`;
